import * as React from 'react';

import type {SalesAutomationStage as SalesAutomationStageFragment} from 'nutshell-graphql-types';

import {UserAssignmentFeatureGate} from '../../../../ui/limits/feature-gates/user-assignment-feature-gate';

import {UserAssignmentsCtaBanner} from '../../ctas/user-assignments-cta-banner';

import {calculateBoardWidth} from '../calculate-board-width';
import {StageCardsUserAssignmentsContainer} from '../card-containers/stage-cards-user-assignments-container';

import {CollapsibleSection} from './collapsible-section';

type Props = {
    stages: SalesAutomationStageFragment[];
    hideCards: boolean;
};

/*
 * Top-level component responsible for rendering the entire "goals"
 * section (row) on the sales automation setup board.
 */
export function SalesAutomationUserAssignments(props: Props) {
    const [isFeatureGateModalOpen, setIsFeatureGateModalOpen] = React.useState(false);

    const boardWidth = calculateBoardWidth(props.stages.length);
    const hasUserAssignments = NutClientConfig.hasLeadUserAssignment;

    const collapsibleSectionContents = hasUserAssignments ? (
        props.stages.map((stage) => {
            return (
                <StageCardsUserAssignmentsContainer
                    key={stage.id}
                    hideCards={props.hideCards}
                    parentId={stage.id}
                />
            );
        })
    ) : (
        <UserAssignmentsCtaBanner
            width={boardWidth}
            onClick={() => setIsFeatureGateModalOpen(true)}
        />
    );

    return (
        <>
            <CollapsibleSection type='userAssignments'>
                {collapsibleSectionContents}
            </CollapsibleSection>
            <UserAssignmentFeatureGate
                isOpen={isFeatureGateModalOpen}
                setIsOpen={setIsFeatureGateModalOpen}
            />
        </>
    );
}
